module.exports = __webpack_public_path__ + "img/ssb_logo_simple.9741e364.png";